import SessionExpiredLayout from '@src/routes/-layouts/session-expired-layout';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/session-expired')({
  component: SessionExpiredLayout,
  validateSearch: z.object({
    reason: z.literal('user_changed').optional().catch(undefined),
  }),
});
